import React from 'react';
import { IoChevronForward } from '../../../node_modules/react-icons/io5/index.esm.js';
import PendingAnimation from '../../PendingAnimation/index.js';
import { genericMemo } from '../../../utils/index.js';
import Button from '../../Button/index.js';
import styles from './styles.css.js';

var _PendingAnimation, _IoChevronForward;

function EmptyOptions(props) {
  const {
    filtered = false,
    pending = false,
    optionsCount,
    totalOptionsCount = 0,
    handleShowMoreClick
  } = props;

  if (pending) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.empty
    }, _PendingAnimation || (_PendingAnimation = /*#__PURE__*/React.createElement(PendingAnimation, null)));
  }

  if (optionsCount <= 0) {
    if (filtered) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.empty
      }, "No matching options available.");
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles.empty
    }, "No options available.");
  } // When optionsCount is zero, totalOptionsCount should be zero as well


  const hiddenOptions = totalOptionsCount - optionsCount;

  if (hiddenOptions > 0) {
    return (
      /*#__PURE__*/
      // FIXME: use message
      React.createElement("div", {
        className: styles.hiddenOptionsCount
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.hiddenCountMessage
      }, `and ${hiddenOptions} more`), handleShowMoreClick && /*#__PURE__*/React.createElement(Button, {
        className: styles.button,
        name: undefined,
        onClick: handleShowMoreClick,
        actions: _IoChevronForward || (_IoChevronForward = /*#__PURE__*/React.createElement(IoChevronForward, null)),
        variant: "transparent"
      }, "show more"))
    );
  }

  return null;
}

var EmptyOptions$1 = genericMemo(EmptyOptions);

export { EmptyOptions$1 as default };
//# sourceMappingURL=index.js.map
